"use client";

import { useEffect } from "react";
import {
  SIGNUP_SOURCE_COOKIE,
  isDirectSource,
  readSignupSourceCookie,
  type SignupSource,
} from "@/lib/signup-source";

// Referrers that are steps of our own flows, not traffic sources.
const IGNORED_REFERRER = /(^|\.)(investmentbastion\.com|accounts\.google\.com|supabase\.co|stripe\.com|localhost)$/i;

/**
 * Remembers where the visitor first came from (referrer, UTM, landing page).
 * A direct visit is upgraded once a real source shows up; a real source is never overwritten.
 */
export default function FirstTouchTracker() {
  useEffect(() => {
    try {
      const { pathname, search, hostname } = window.location;
      if (pathname.startsWith("/auth") || pathname.startsWith("/admin")) return;

      const params = new URLSearchParams(search);
      let ref: string | undefined;
      if (document.referrer) {
        try {
          const host = new URL(document.referrer).hostname.replace(/^www\./, "");
          if (host && host !== hostname && !IGNORED_REFERRER.test(host)) ref = host;
        } catch { /* bad referrer */ }
      }

      const touch: SignupSource = {
        ref,
        utm_source: params.get("utm_source") || undefined,
        utm_medium: params.get("utm_medium") || undefined,
        utm_campaign: params.get("utm_campaign") || undefined,
        landing: pathname.slice(0, 120),
        ts: new Date().toISOString(),
      };

      const existing = readSignupSourceCookie();
      if (existing && (!isDirectSource(existing) || isDirectSource(touch))) return;

      const domain = hostname.endsWith("investmentbastion.com") ? "domain=.investmentbastion.com;" : "";
      const value = encodeURIComponent(JSON.stringify(touch));
      document.cookie = `${SIGNUP_SOURCE_COOKIE}=${value};max-age=${60 * 60 * 24 * 180};path=/;${domain}SameSite=Lax`;
    } catch { /* never break the page */ }
  }, []);

  return null;
}
